import React, { useEffect } from 'react'
import dynamic from 'next/dynamic'
import Block from '../../adapters/helpers/Block'
import Image from '../Image/Image'
const MarkdownText = dynamic(() => import('../MarkdownText/MarkdownText'))
import { mediaQueryHOC } from '../../adapters/helpers/Hooks';

function MultiTextComponent(props) {
    const document = props?.document
    const isMedium = props?.isMedium
    const contentDetails = document?.fields
    const desktopBannerImage = contentDetails?.desktopImage
    const mobileBannerImage = contentDetails?.mobileImage

    return (
        <div className={contentDetails.className}>
            <div className='multiText-img-rap'>
                <Image
                    className={isMedium ? 'multitextImage-mobile' : 'multiTextImage-desktop'}
                    image={isMedium ? mobileBannerImage : desktopBannerImage}
                    altText={isMedium ? mobileBannerImage?.fields?.alternateText : desktopBannerImage?.fields?.alternateText}
                />
            </div>

            {contentDetails?.title && <MarkdownText className={'multiText-comp-title'} value={contentDetails?.title} />}
            <div className='multi-text-contentwrap'>
                {contentDetails?.multiText?.map((res, index) => {
                    return (
                        <p className={res?.fields?.classNames} key={index}>
                            {res?.fields?.text}
                        </p>
                    )
                })}
            </div>
        </div>
    )
}

export default mediaQueryHOC(MultiTextComponent)
